import { App } from "vue";

declare global {
  interface Window {
    HT?: any;
  }
}

const loadHandTalkScript = (
  scriptId: string,
  src: string,
  onLoad: () => void,
  onError: () => void
) => {
  if (document.getElementById(scriptId)) return;
  const script = document.createElement("script");
  script.id = scriptId;
  script.src = src;
  script.async = true;
  script.onload = onLoad;
  script.onerror = onError;
  document.head.appendChild(script);
};

const initializeHandTalk = (app: App, token: string) => {
  if (!window.HT) return;

  try {
    const ht = new window.HT({ token });
    if (typeof ht.init === "function") {
      ht.init();
      app.config.globalProperties.$handTalk = ht;
    }
  } catch (error) {
    console.error("HandTalk error on init:", error);
  }
};

export default {
  install(app: App) {
    const scriptId = "handtalk-script";
    const scriptSrc = "https://plugin.handtalk.me/web/latest/handtalk.min.js";

    loadHandTalkScript(
      scriptId,
      scriptSrc,
      () => initializeHandTalk(app, String(process.env.VUE_APP_HANDTALK_TOKEN)),
      () => console.error("Error loading HandTalk script")
    );
  },
};
